/**
 * Feature Flags
 * 
 * Controla a ativação/desativação de funcionalidades que ainda
 * não estão prontas para produção.
 */
const featureFlags = {
  /** Habilita a funcionalidade de substituir publicador cancelado */
  SUBSTITUIR_PUBLICADOR: true,
};

export default featureFlags;
